export default "__VITE_ASSET__BPctlnTr__"